import React from 'react';
import { useIntl } from 'react-intl';
import { Typography, Box } from '@mui/material';
import RegistrationWrapper from './RegistrationWrapper';

const EmailChangedLandingPage = () => {
  const { formatMessage } = useIntl();

  return (
    <RegistrationWrapper>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        textAlign="center"
        py={6}
        px={3}
        data-testid="email-changed-landing"
      >
        <Typography variant="h4" component="h1" gutterBottom sx={{ color: 'white', fontWeight: 600 }} data-testid="email-changed-title">
          {formatMessage({ id: 'email-changed.title' })}
        </Typography>

        <Typography variant="body1" sx={{ color: 'white', maxWidth: 420, mt: 2 }} data-testid="email-changed-message">
          {formatMessage({ id: 'email-changed.message' })}
        </Typography>
      </Box>
    </RegistrationWrapper>
  );
};

export default EmailChangedLandingPage;
